const DEFAULT_TITLE = 'Spotahome';
const FIRST_PAGE = 1;

const getTitle = title =>
  title ? `${title} | ${DEFAULT_TITLE}` : DEFAULT_TITLE;

const formatRef = id => `(ref: ${id})`;

export const getPageTitleFromSeo = (metadata = {}) => {
  const { title } = metadata.basic || {};
  return getTitle(title);
};

export const getSearchPageTitle = (metadata = {}, page = FIRST_PAGE) => {
  const { title } = metadata.basic || {};
  const composedTitle = page === FIRST_PAGE ? title : `${title} ${page}`;
  return getTitle(composedTitle);
};

export const getPageTitleForRentableUnit = (rentableUnitData, locale) => {
  const { listing, seo, isRoomsAggregator } = rentableUnitData;

  const contents = listing.contents[locale] || listing.contents.en;
  const title =
    (isRoomsAggregator
      ? contents.propertySeoMetaTitle
      : contents.seoMetaTitle) || contents.title;

  const titleWithRef = title
    ? `${title} ${formatRef(listing.id)}`
    : seo.basic.title || '';
  return getTitle(titleWithRef);
};

export const getPageDescriptionForRentableUnit = (rentableUnitData, locale) => {
  const { listing, seo } = rentableUnitData;
  const contents = listing.contents[locale] || listing.contents.en;
  const description =
    contents.seoMetaDescription ||
    contents.description ||
    seo.basic.description;

  return description ? `${description} ${formatRef(listing.id)}` : '';
};

export default {
  getPageTitleFromSeo,
  getSearchPageTitle,
  getPageTitleForRentableUnit,
  getPageDescriptionForRentableUnit
};
